/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_CreateInputs */

const th_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างห้องทดสอบ`)
};

const en_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create test room`)
};

const ja_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テストルームを作成`)
};

const zh_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建测试房间`)
};

const es_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear sala de prueba`)
};

const pt_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar sala de teste`)
};

const id_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat ruang uji`)
};

const fr_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un salon de test`)
};

const tl_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gumawa ng test room`)
};

const vi_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phòng thử`)
};

const ko_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`테스트 방 만들기`)
};

const de_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testraum anlegen`)
};

const ru_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать тестовую комнату`)
};

const tr_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test odası oluştur`)
};

const it_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una stanza di prova`)
};

const pl_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz pokój testowy`)
};

const uk_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Створити тестову кімнату`)
};

const hi_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परीक्षण कक्ष बनाएँ`)
};

const ar_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء غرفة اختبار`)
};

const ms_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cipta bilik ujian`)
};

const bn_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরীক্ষামূলক কক্ষ তৈরি করুন`)
};

const zh_tw2_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立測試房間`)
};

const zh_hk2_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立測試房間`)
};

const ur_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آزمائشی کمرہ بنائیں`)
};

const fa_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ساختن اتاق آزمایشی`)
};

const sw_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua chumba cha majaribio`)
};

const nl_meeting_test_create = /** @type {(inputs: Meeting_Test_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testruimte aanmaken`)
};

/**
* | output |
* | --- |
* | "Create test room" |
*
* @param {Meeting_Test_CreateInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_create = /** @type {((inputs?: Meeting_Test_CreateInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_CreateInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_create(inputs)
	if (locale === "ja") return ja_meeting_test_create(inputs)
	if (locale === "zh") return zh_meeting_test_create(inputs)
	if (locale === "es") return es_meeting_test_create(inputs)
	if (locale === "pt") return pt_meeting_test_create(inputs)
	if (locale === "id") return id_meeting_test_create(inputs)
	if (locale === "fr") return fr_meeting_test_create(inputs)
	if (locale === "tl") return tl_meeting_test_create(inputs)
	if (locale === "vi") return vi_meeting_test_create(inputs)
	if (locale === "ko") return ko_meeting_test_create(inputs)
	if (locale === "de") return de_meeting_test_create(inputs)
	if (locale === "ru") return ru_meeting_test_create(inputs)
	if (locale === "tr") return tr_meeting_test_create(inputs)
	if (locale === "it") return it_meeting_test_create(inputs)
	if (locale === "pl") return pl_meeting_test_create(inputs)
	if (locale === "uk") return uk_meeting_test_create(inputs)
	if (locale === "hi") return hi_meeting_test_create(inputs)
	if (locale === "ar") return ar_meeting_test_create(inputs)
	if (locale === "ms") return ms_meeting_test_create(inputs)
	if (locale === "bn") return bn_meeting_test_create(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_create(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_create(inputs)
	if (locale === "ur") return ur_meeting_test_create(inputs)
	if (locale === "fa") return fa_meeting_test_create(inputs)
	if (locale === "sw") return sw_meeting_test_create(inputs)
	if (locale === "nl") return nl_meeting_test_create(inputs)
	return en_meeting_test_create(inputs)
});